import { put, takeLatest } from 'redux-saga/effects';
import { NetworkManager } from '../../api/NetworkManager';
import {
  trxHistoryApiCallLoadingRequest,
  trxHistoryApiCallSuccess,
  trxHistoryApiCallFailure,
} from './recentTrxHistorySlice';
import { GET_RECENT_TRX_HISTORY_DATA } from './types';

export function* getRecentTrxHistoryData(action) {
  try {
    yield put(trxHistoryApiCallLoadingRequest(action.payload.isLoading));
    const response = yield NetworkManager.getRecentTrxHistory({
      token: action.payload.token,
      policyNumber: action.payload.policyNumber,
    });
    if (response) {
      yield put(trxHistoryApiCallSuccess(response.data));
    }
  } catch (error) {
    yield put(trxHistoryApiCallFailure(error));
  }
}

export function* watchRecentTrxHistory() {
  yield takeLatest(GET_RECENT_TRX_HISTORY_DATA, getRecentTrxHistoryData);
}
